module.exports = __webpack_public_path__ + "img/IconUpload.f781fce2.svg";